'use strict';

Object.defineProperty(exports, "__esModule", { value: true });
exports.SYSTEM_KEYS = exports.SYSTEM_KEYS_QUERY_MAP = exports.SYSTEM_KEYS_ATTR_MAP = void 0;
exports.SYSTEM_KEYS_ATTR_MAP = {
    projectName: 'projectname',
    requestId: 'requestid',
    versionCommit: 'versioncommit',
};
exports.SYSTEM_KEYS_QUERY_MAP = {
    projectName: 'projectName',
    requestId: 'requestId',
    versionCommit: 'versionCommit',
};
exports.SYSTEM_KEYS = {
    projectName: 'projectName',
    requestId: 'requestId',
    versionCommit: 'version.commit',
};
//# sourceMappingURL=constants.js.map
